class BlockListingVideos{

    constructor() {

        let blocks = document.querySelectorAll('.block-listing-videos');

        blocks.forEach( (block) => {

            let cards = block.querySelectorAll('.card-video');
            cards.forEach((card) => {
                const overlay = card;
                const openBtn = card.querySelector('.open-video');
                const closeBtn = card.querySelector('.close-video');
                const player = card.querySelector('.card-player');
                const iframe = player.querySelector('iframe');

                openBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    player.classList.add('active');
                });

                player.addEventListener('click', (e) => {
                    if (e.target === player) {
                        e.preventDefault();
                        player.classList.remove('active');
                        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command',
                            func: 'stopVideo' }), '*');
                    }
                });

            });
        });
    }

    closePlayer() {
        let player = document.querySelector('.card-player.active');
        player.classList.remove('active');
    }
}